import AccessDenied, {
  IAccessDeniedProps,
} from "../components/AccessDenied/AccessDenied";
import FeatureReached, {
  IFeatureReachedProps,
} from "../components/FeatureReached/FeatureReached";
import PlanDenied, {
  IPlanDeniedProps,
} from "../components/PlanDenied/PlanDenied";
import { MODAL_TYPE_T } from "@Models/access";

export interface IModalConfig {
  ACCESS_DENIED: {
    component: typeof AccessDenied;
    props: IAccessDeniedProps;
  };
  PLAN_LIMIT_REACHED: {
    component: typeof PlanDenied;
    props: IPlanDeniedProps;
  };
  FEATURE_LIMITED_REACHED: {
    component: typeof FeatureReached;
    props: IFeatureReachedProps;
  };
}

function useAccessModalChildren<T extends MODAL_TYPE_T>(
  type: T,
  props: IModalConfig[T]["props"],
  onClose?: () => void
) {
  switch (type) {
    case "ACCESS_DENIED":
      return <AccessDenied {...(props as IAccessDeniedProps)} />;
    case "PLAN_LIMIT_REACHED":
      return <PlanDenied {...(props as IPlanDeniedProps)} />;
    case "FEATURE_LIMITED_REACHED":
      return (
        <FeatureReached
          {...(props as IFeatureReachedProps)}
          onClose={onClose}
        />
      );
    default:
      return null;
  }
}

export default useAccessModalChildren;
